import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Select from "react-select";
import moment from "moment";
import imgDummy from "assets/img/img-dummy.png";
import logoShipper from "assets/img/logo-shipper.png";
import { UPLOAD_URL, MAX_UPLOAD } from "../../actions/constant";
import { userChangePassword } from "../../actions/userAction";
import { provinsiFetchAll } from "../../actions/provinsiAction";
import { AvForm, AvInput } from "availity-reactstrap-validation";
import { kotaFetchSub, kotaGetSuccess } from "../../actions/kotaAction";

import {
  shipperFetchUser,
  shipperUpdate,
  shipperUpdateProfile,
} from "../../actions/shipperAction";
import NumberFormat from "react-number-format";
import {
  Card,
  CardBody,
  Col,
  Row,
  InputGroup,
  InputGroupAddon,
  CardHeader,
  InputGroupText,
  Nav,
  NavLink,
  NavItem,
  TabContent,
  TabPane,
  Media,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import { doLogout } from "actions/authAction";
import { withRouter } from "react-router-dom";

let userId = localStorage.getItem("tolaut@userId") || null;
let token = localStorage.getItem("tolaut@token") || null;

const optionStatus = [
  { value: "Pusat", label: "Pusat" },
  { value: "Cabang", label: "Cabang" },
];

const optionJenis = [
  { value: "BUMN", label: "BUMN" },
  { value: "Swasta", label: "Swasta" },
];

const optionIdentify1 = [
  { value: "KTP", label: "KTP" },
  { value: "SIM", label: "SIM" },
  { value: "Kartu Identitas Lainnya", label: "Kartu Identitas Lainnya" },
];

const optionIdentify2 = [
  { value: "KTP", label: "KTP" },
  { value: "SIM", label: "SIM" },
  { value: "Kartu Identitas Lainnya", label: "Kartu Identitas Lainnya" },
];

const optionIdentify3 = [
  { value: "KTP", label: "KTP" },
  { value: "SIM", label: "SIM" },
  { value: "Kartu Identitas Lainnya", label: "Kartu Identitas Lainnya" },
];

class ProfileShipper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailProfile: [],
      activeTab: new Array(4).fill("1"),
      submited: false,
      updateCity: false,
      updateProfileSubmitted: false,
      provinsi_id: "",
      kota_id: "",
      status_perusahaan: "",
      jenis_user: "",
      npwp: "",
      identify_officer1: "",
      identify_officer2: "",
      identify_officer3: "",
    };

    this.toggle = this.toggle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.onProvChange = this.onProvChange.bind(this);
    this.onKotaChange = this.onKotaChange.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.onStatusChange = this.onStatusChange.bind(this);
    this.onJenisChange = this.onJenisChange.bind(this);
    this.onIdentify1 = this.onIdentify1.bind(this);
    this.onIdentify2 = this.onIdentify2.bind(this);
    this.onIdentify3 = this.onIdentify3.bind(this);
  }

  componentDidMount() {
    this.props.shipperFetchUser(userId);
    this.props.provinsiFetchAll(token);
  }

  componentDidUpdate(prevProps) {
    if (userId === null) {
      this.setState({ showPrompt: true });
      window.location.reload();
    }

    if (
      prevProps.shipperUpdateUserSuccess !== this.props.shipperUpdateUserSuccess
    ) {
      window.alert(
        "Register ulang berhasil. Silakan menunggu approval dari regulator atau otoritas terkait"
      );
    }
  }

  componentWillUnmount() {
    this.setState({ updateCity: false });
    this.props.kotaGetSuccess(false, null);
  }

  handleNPWP(values) {
    this.setState({
      npwp: values,
    });
  }
  handleKTP(values) {
    this.setState({
      ktp: values,
    });
  }
  handleAktaPendiri(values) {
    this.setState({
      akta_pendirian: values,
    });
  }
  handleTDP(values) {
    this.setState({
      tanda_daftar_perusahaan: values,
    });
  }
  handleSKD(values) {
    this.setState({
      surat_keterangan_domisili: values,
    });
  }
  handleSPS(values) {
    this.setState({
      surat_penunjukan_shipper: values,
    });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps?.isSuccess) {
      this.setState({
        detailProfile: nextProps?.profile?.data[0],
        npwp: nextProps?.profile?.data[0]?.npwp,
      });
    }

    if (nextProps?.isSuccess && this.state.updateCity) {
      this.setState({ updateCity: true });
      this.props.kotaFetchSub(
        "get_propinsi/" + nextProps?.profile?.data[0]?.provinsi_id
      );
    }

    if (nextProps?.cpwdSuccess && this.state.submited) {
      this.setState({
        submited: false,
      });

      window.location.reload();
    }

    if (nextProps?.updateSuccess && this.state.updateProfileSubmitted) {
      this.setState({ updateProfileSubmitted: false });
      this.props.shipperFetchUser(userId);
      this.toggle(1, "1");
    }
    if (userId === null && !this.state.submited) {
      //   this.props.shipperFetchUser(userId);
      //   this.props.provinsiFetchAll(token);
    }
  }

  onInputChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({
      detailItem: { ...this.state.detailItem, [name]: value },
    });
  }

  handleFile(event) {
    const target = event.target;
    const value = target.files[0];
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  toggle(tabPane, tab) {
    const newArray = this.state.activeTab.slice();
    newArray[tabPane] = tab;
    this.setState({
      activeTab: newArray,
    });
  }

  handleChangePassword(event, values) {
    if (values.password.length < 6) {
      alert("Password minimal 6 karakter");
      return;
    }
    this.setState({
      submited: true,
    });
    const email = localStorage.getItem("tolaut@email") || null;
    values.email = email;
    values.id = userId;
    this.props.userChangePassword(values);
  }

  handleSubmit(event, values) {
    values.npwp = this.state.npwp;
    values.siup_doc = this.state.siup_doc;
    values.npwp_doc = this.state.npwp_doc;
    values.surat_rekomendasi = this.state.surat_rekomendasi;
    values.logo_perusahaan = this.state.logo_perusahaan;
    values.foto_ttd = this.state.foto_ttd;
    values.identify_officerdoc1 = this.state.identify_officerdoc1;
    values.identify_officerdoc2 = this.state.identify_officerdoc2;
    values.identify_officerdoc3 = this.state.identify_officerdoc3;
    values.ktp = this.state.ktp;
    values.foto_ktp = this.state.foto_ktp;
    values.akta_pendirian = this.state.akta_pendirian;
    values.akta_pendirian_doc = this.state.akta_pendirian_doc;
    values.tanda_daftar_perusahaan = this.state.tanda_daftar_perusahaan;
    values.tanda_daftar_perusahaan_doc = this.state.tanda_daftar_perusahaan_doc;
    values.surat_keterangan_domisili = this.state.surat_keterangan_domisili;
    values.surat_keterangan_domisili_doc =
      this.state.surat_keterangan_domisili_doc;
    values.surat_penunjukan_shipper = this.state.surat_penunjukan_shipper;
    values.surat_penunjukan_shipper_doc =
      this.state.surat_penunjukan_shipper_doc;
    if (this.state.provinsi_id !== "") {
      values.provinsi_id = this.state.provinsi_id;
    } else {
      delete values.provinsi_id;
    }

    if (this.state.kota_id !== "") {
      values.kota_id = this.state.kota_id;
    } else {
      delete values.kota_id;
    }

    if (this.state.status_perusahaan !== "") {
      values.status_perusahaan = this.state.status_perusahaan;
    } else {
      delete values.status_perusahaan;
    }

    if (this.state.jenis_user !== "") {
      values.jenis_user = this.state.jenis_user;
    } else {
      delete values.jenis_user;
    }

    if (this.state.identify_officer1 !== "") {
      values.identify_officer1 = this.state.identify_officer1;
    } else {
      delete values.identify_officer1;
    }

    if (this.state.identify_officer2 !== "") {
      values.identify_officer2 = this.state.identify_officer2;
    } else {
      delete values.identify_officer2;
    }

    if (this.state.identify_officer3 !== "") {
      values.identify_officer3 = this.state.identify_officer3;
    } else {
      delete values.identify_officer3;
    }

    // this.props.shipperUpdateProfile(values);

    // window.alert(
    //   "Register ulang berhasil. Silakan menunggu persetujuan dari otoritas terkait"
    // );
    if (localStorage.getItem("tolaut@status") === "-7") {
      this.props.shipperUpdateProfile({ id: userId });
    }

    this.props.shipperUpdate(values);

    this.setState({
      updateProfileSubmitted: true,
      updateCity: false,
      provinsi_id: "",
      kota_id: "",
      status_perusahaan: "",
      jenis_user: "",
      identify_officer1: "",
      identify_officer2: "",
      identify_officer3: "",
    });
  }

  onProvChange(option) {
    if (option?.value !== "") {
      this.props.kotaFetchSub("get_propinsi/" + option?.value);
      this.setState({
        provinsi_id: option?.value,
        kota_id: "",
      });
    }
  }

  onKotaChange(option) {
    this.setState({ kota_id: option.value });
  }

  onStatusChange(option) {
    this.setState({ status_perusahaan: option.value });
  }

  onJenisChange(option) {
    this.setState({ jenis_user: option.value });
  }

  onIdentify1(option) {
    this.setState({ identify_officer1: option.value });
  }

  onIdentify2(option) {
    this.setState({ identify_officer2: option.value });
  }

  onIdentify3(option) {
    this.setState({ identify_officer3: option.value });
  }

  handleLogout() {
    this.props.doLogout();

    this.props.history.push("/login");
  }

  renderData() {
    if (this.props.isSuccess) {
      const defaultValues = {
        id: this.props.profile?.data[0]?.id,
        nama_perusahaan: this.props.profile?.data[0]?.nama_perusahaan,
        alamat: this.props.profile?.data[0]?.alamat,
        email: this.props.profile?.data[0]?.email,
        fax: this.props.profile?.data[0]?.fax,
        telp: this.props.profile?.data[0]?.telp,
        siup: this.props.profile?.data[0]?.siup,
        npwp: this.props.profile?.data[0]?.npwp,
        nama_pic: this.props.profile?.data[0]?.nama_pic,
        fax_pic: this.props.profile?.data[0]?.fax_pic,
        hp_pic: this.props.profile?.data[0]?.hp_pic,
        telp_pic: this.props.profile?.data[0]?.telp_pic,
        email_pic: this.props.profile?.data[0]?.email_pic,
        provinsi_id: this.props.profile?.data[0]?.provinsi_id,
        provinsi: this.props.profile?.data[0]?.provinsi,
        kota_id: this.props.profile?.data[0]?.kota_id,
        kota: this.state.provinsi_id
          ? "-- Pilih Kota --"
          : this.props.profile?.data[0]?.kota,
        jenis_user: this.props.profile?.data[0]?.jenis_user,
        status_perusahaan: this.props.profile?.data[0]?.status_perusahaan,
        nama_officer1: this.props.profile?.data[0]?.nama_officer1,
        identify_officer1: this.props.profile?.data[0]?.identify_officer1,
        identify_officer1: this.props.profile?.data[0]?.identify_officer1,
        telp_officer1: this.props.profile?.data[0]?.telp_officer1,
        nama_officer2: this.props.profile?.data[0]?.nama_officer2,
        identify_officer2: this.props.profile?.data[0]?.identify_officer2,
        identify_officer2: this.props.profile?.data[0]?.identify_officer2,
        telp_officer2: this.props.profile?.data[0]?.telp_officer2,
        nama_officer3: this.props.profile?.data[0]?.nama_officer3,
        identify_officer3: this.props.profile?.data[0]?.identify_officer3,
        telp_officer3: this.props.profile?.data[0]?.telp_officer3,
        identify_officer3: this.props.profile?.data[0]?.identify_officer3,
        tmpt_lahir: this.props.profile?.data[0]?.tmpt_lahir,
        tgl_lahir: moment(this.props.profile?.data[0]?.tgl_lahir).format(
          "YYYY-MM-DD"
        ),
        jabatan: this.props.profile?.data[0]?.jabatan,
        nama_ttd: this.props.profile?.data[0]?.nama_ttd,
        ktp: this.props.profile?.data[0]?.ktp,
        akta_pendirian: this.props.profile?.data[0]?.akta_pendirian,
        tanda_daftar_perusahaan:
          this.props.profile?.data[0]?.tanda_daftar_perusahaan,
        surat_keterangan_domisili:
          this.props.profile?.data[0]?.surat_keterangan_domisili,
        surat_penunjukan_shipper:
          this.props.profile?.data[0]?.surat_penunjukan_shipper,
        no_pmku: this.props.profile?.data[0]?.no_pmku,
        tgl_pmku: moment(this.props.profile?.data[0]?.tgl_pmku).format(
          "YYYY-MM-DD"
        ),
      };

      const { provinsi_id } = this.state.provinsi_id;
      const { kota_id } = this.state.kota_id;
      const { status_perusahaan } = this.state.status_perusahaan;
      const { jenis_user } = this.state.jenis_user;
      const { identify_officer1 } = this.state.identify_officer1;
      const { identify_officer2 } = this.state.identify_officer2;
      const { identify_officer3 } = this.state.identify_officer3;
      const { showPrompt } = this.state;

      return (
        <div className="animated fadeIn profile">
          <header className="white pt-3 relative card">
            <div className="container-fluid ">
              <div className="row p-t-b-10 ">
                <div className="col">
                  <div className="pb-3">
                    <Row>
                      <Col xs="12" sm="2" lg="2">
                        {this.props.profile?.data[0]?.logo_perusahaan ? (
                          <img
                            src={
                              UPLOAD_URL +
                              this.props.profile?.data[0]?.logo_perusahaan
                            }
                            className="img-fluid"
                            alt="user"
                          />
                        ) : (
                          <img
                            src={logoShipper}
                            className="img-fluid"
                            alt="user"
                          />
                        )}
                      </Col>
                      <Col xs="12" sm="10" lg="10">
                        <h3 className="mt-3 ">
                          {this.props.profile?.data[0]?.nama_perusahaan}
                        </h3>
                        {this.props.profile?.data[0]?.email}
                        <hr />
                        <div>
                          <h6>
                            Jenis Perusahaan:{" "}
                            {this.props.profile?.data[0]?.jenis_user}{" "}
                          </h6>
                          <p>
                            Status Perusahaan :{" "}
                            {this.props.profile?.data[0]?.status_perusahaan}
                          </p>
                        </div>
                        <div>
                          <Button
                            color="primary"
                            onClick={() => {
                              this.handleLogout();
                            }}
                          >
                            Log Out
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>

              <Nav tabs>
                <NavItem>
                  <NavLink
                    active={this.state.activeTab[1] === "1"}
                    onClick={() => {
                      this.toggle(1, "1");
                    }}
                  >
                    <i className="fa fa-user-circle-o mr-2"> </i> Profile
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    active={this.state.activeTab[1] === "4"}
                    onClick={() => {
                      this.toggle(1, "4");
                    }}
                  >
                    <i className="fa fa-users mr-2"> </i> Officer
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    active={this.state.activeTab[1] === "2"}
                    onClick={() => {
                      this.toggle(1, "2");
                    }}
                  >
                    <i className="fa fa-lock mr-2"></i> Ubah Password
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    active={this.state.activeTab[1] === "3"}
                    onClick={() => {
                      this.toggle(1, "3");
                    }}
                  >
                    <i className="icon-note mr-2"></i> Edit Profile
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </header>
          <TabContent activeTab={this.state.activeTab[1]}>
            <TabPane tabId="1">
              <Row>
                <Col sm="6" lg="6">
                  <Card>
                    <CardBody>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">
                          <i className="fa fa-file-text-o text-primary mr-3"></i>
                          <strong className="s-12">SIUP</strong>{" "}
                          <span className="float-right s-12">
                            {this.props.profile?.data[0]?.siup}
                          </span>
                        </li>
                        <li className="list-group-item">
                          <i className="fa fa-file-text-o text-primary s-15 mr-3"></i>
                          <strong className="s-12">NPWP</strong>{" "}
                          <span className="float-right s-12">
                            {this.props.profile?.data[0]?.npwp}
                          </span>
                        </li>
                        <li className="list-group-item">
                          <i className="fa fa-phone text-primary s-15 mr-3"></i>
                          <strong className="s-12">Phone</strong>{" "}
                          <span className="float-right s-12">
                            {this.props.profile?.data[0]?.telp}
                          </span>
                        </li>
                        <li className="list-group-item">
                          <i className="fa fa-fax text-primary mr-3"></i>
                          <strong className="s-12">Fax</strong>{" "}
                          <span className="float-right s-12">
                            {this.props.profile?.data[0]?.fax}
                          </span>
                        </li>
                        <li className="list-group-item">
                          <Row>
                            <Col md="5" lg="5">
                              <i className="fa fa-address-card-o text-primary mr-3"></i>
                              <strong className="s-12">Address</strong>
                            </Col>
                            <Col md="7" lg="7" className="text-right">
                              <span className="float-right s-12">
                                {this.props.profile?.data[0]?.alamat}
                              </span>
                              <br />
                              <span>
                                {this.props.profile?.data[0]?.kota} -{" "}
                                {this.props.profile?.data[0]?.provinsi}
                              </span>
                            </Col>
                          </Row>
                        </li>
                      </ul>
                    </CardBody>
                  </Card>
                </Col>
                <Col sm="6" lg="6">
                  <Card>
                    <CardBody>
                      <h5 className="text-primary">Data PIC</h5>
                      <hr></hr>
                      <h5>{this.props.profile?.data[0]?.nama_pic}</h5>
                      <p>{this.props.profile?.data[0]?.email_pic}</p>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">
                          <i className="fa fa-mobile-phone text-primary mr-3"></i>
                          <strong className="s-12">No Handphone</strong>{" "}
                          <span className="float-right s-12">
                            {this.props.profile?.data[0]?.hp_pic}
                          </span>
                        </li>
                        <li className="list-group-item">
                          <i className="fa fa-phone text-primary s-15 mr-3"></i>
                          <strong className="s-12">Phone</strong>{" "}
                          <span className="float-right s-12">
                            {this.props.profile?.data[0]?.telp_pic}
                          </span>
                        </li>
                        <li className="list-group-item">
                          <i className="fa fa-fax text-primary mr-3"></i>
                          <strong className="s-12">Fax</strong>{" "}
                          <span className="float-right s-12">
                            {this.props.profile?.data[0]?.fax_pic}
                          </span>
                        </li>
                      </ul>
                    </CardBody>
                  </Card>
                </Col>
                <Col sm="6" lg="6">
                  <Card>
                    <CardBody>
                      <h5 className="text-primary">PMKU</h5>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">
                          <i className="fa fa-file-text-o text-primary mr-3"></i>
                          <strong className="s-12">No PMKU</strong>{" "}
                          <span className="float-right s-12">
                            {this.props.profile?.data[0]?.no_pmku}
                          </span>
                        </li>
                        <li className="list-group-item">
                          <i className="fa fa-file-text-o text-primary s-15 mr-3"></i>
                          <strong className="s-12">Tanggal PMKU</strong>{" "}
                          <span className="float-right s-12">
                            {moment(
                              this.props.profile?.data[0]?.tgl_pmku
                            ).format("YYYY-MM-DD")}
                          </span>
                        </li>
                      </ul>
                    </CardBody>
                  </Card>
                </Col>
                <Col sm="6" lg="6">
                  <Card>
                    <CardBody>
                      <h5 className="text-primary">Data Penanda Tangan</h5>
                      <hr></hr>
                      <h5>{this.props.profile?.data[0]?.nama_ttd}</h5>
                      {this.props.profile?.data[0]?.foto_ttd ? (
                        <img
                          src={
                            UPLOAD_URL + this.props.profile?.data[0]?.foto_ttd
                          }
                          className=" img-thumbnail"
                          alt="ttd"
                          width="200px"
                        />
                      ) : (
                        <img
                          src={imgDummy}
                          className=" img-thumbnail"
                          alt="ttd"
                          width="200px"
                        />
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col xs="12" lg="6">
                  <Card>
                    <CardHeader>
                      <strong>File NPWP</strong>
                    </CardHeader>
                    <CardBody
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "15px",
                      }}
                    >
                      <a
                        href={
                          UPLOAD_URL + this.props.profile?.data[0]?.npwp_doc
                        }
                        target="_blank"
                      >
                        {this.props.profile?.data[0]?.npwp_doc ? (
                          this.props.profile?.data[0]?.npwp_doc.indexOf(
                            "pdf"
                          ) !== -1 ? (
                            <iframe
                              src={
                                UPLOAD_URL +
                                this.props.profile?.data[0]?.npwp_doc
                              }
                              title="npwp"
                              frameBorder="0"
                              height="200px"
                              width="100%"
                            ></iframe>
                          ) : (
                            <img
                              src={
                                UPLOAD_URL +
                                this.props.profile?.data[0]?.npwp_doc
                              }
                              className="img-fluid"
                              alt="npwp"
                              style={{ height: "200px" }}
                            />
                          )
                        ) : (
                          <img
                            src={imgDummy}
                            className=" img-thumbnail"
                            alt="ttd"
                            style={{ height: "200px" }}
                          />
                        )}
                      </a>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" lg="6">
                  <Card>
                    <CardHeader>
                      <h4>File KTP</h4>
                    </CardHeader>
                    <CardBody
                      style={{
                        display: "grid",
                        justifyContent: "center",
                        padding: "15px",
                      }}
                    >
                      <div>
                        <label>
                          <strong>Nomor KTP:</strong>{" "}
                          {this.props.profile?.data[0]?.ktp}
                        </label>
                      </div>
                      <a
                        href={
                          UPLOAD_URL + this.props.profile?.data[0]?.foto_ktp
                        }
                        target="_blank"
                      >
                        {this.props.profile?.data[0]?.foto_ktp ? (
                          <img
                            src={
                              UPLOAD_URL + this.props.profile?.data[0]?.foto_ktp
                            }
                            className="img-fluid"
                            alt="foto ktp"
                            style={{ height: "200px" }}
                          />
                        ) : (
                          <img
                            src={imgDummy}
                            className=" img-thumbnail"
                            alt="ttd"
                            style={{ height: "200px" }}
                          />
                        )}
                      </a>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" lg="6">
                  <Card>
                    <CardHeader>
                      <h4>File Tanda daftar perusahaan</h4>
                    </CardHeader>
                    <CardBody
                      style={{
                        display: "grid",
                        justifyContent: "center",
                        padding: "15px",
                      }}
                    >
                      <div>
                        <label>
                          <strong>Nomor Tanda daftar perusahaan:</strong>{" "}
                          {this.props.profile?.data[0]?.tanda_daftar_perusahaan}
                        </label>
                      </div>
                      <a
                        href={
                          UPLOAD_URL +
                          this.props.profile?.data[0]
                            ?.tanda_daftar_perusahaan_doc
                        }
                        target="_blank"
                      >
                        {this.props.profile?.data[0]
                          ?.tanda_daftar_perusahaan_doc ? (
                          <img
                            src={
                              UPLOAD_URL +
                              this.props.profile?.data[0]
                                ?.tanda_daftar_perusahaan_doc
                            }
                            className="img-fluid"
                            alt="foto Tanda daftar perusahaan"
                            style={{ height: "200px" }}
                          />
                        ) : (
                          <img
                            src={imgDummy}
                            className=" img-thumbnail"
                            alt="ttd"
                            style={{ height: "200px" }}
                          />
                        )}
                      </a>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" lg="6">
                  <Card>
                    <CardHeader>
                      <h4>File Surat keterangan domisili</h4>
                    </CardHeader>
                    <CardBody
                      style={{
                        display: "grid",
                        justifyContent: "center",
                        padding: "15px",
                      }}
                    >
                      <div>
                        <label>
                          <strong>Nomor Surat keterangan domisili:</strong>{" "}
                          {
                            this.props.profile?.data[0]
                              ?.surat_keterangan_domisili
                          }
                        </label>
                      </div>
                      <a
                        href={
                          UPLOAD_URL +
                          this.props.profile?.data[0]
                            ?.surat_keterangan_domisili_doc
                        }
                        target="_blank"
                      >
                        {this.props.profile?.data[0]
                          ?.surat_keterangan_domisili_doc ? (
                          <img
                            src={
                              UPLOAD_URL +
                              this.props.profile?.data[0]
                                ?.surat_keterangan_domisili_doc
                            }
                            className="img-fluid"
                            alt="foto Surat keterangan domisili"
                            style={{ height: "200px" }}
                          />
                        ) : (
                          <img
                            src={imgDummy}
                            className=" img-thumbnail"
                            alt="ttd"
                            style={{ height: "200px" }}
                          />
                        )}
                      </a>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" lg="6">
                  <Card>
                    <CardHeader>
                      <strong>File SIUP</strong>
                    </CardHeader>
                    <CardBody
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "15px",
                      }}
                    >
                      <a
                        href={
                          UPLOAD_URL + this.props.profile?.data[0]?.siup_doc
                        }
                        target="_blank"
                      >
                        {this.props.profile?.data[0]?.siup_doc ? (
                          this.props.profile?.data[0]?.siup_doc.indexOf(
                            "pdf"
                          ) !== -1 ? (
                            <iframe
                              src={
                                UPLOAD_URL +
                                this.props.profile?.data[0]?.siup_doc
                              }
                              title="siup"
                              frameBorder="0"
                              style={{ height: "200px" }}
                              width="100%"
                            ></iframe>
                          ) : (
                            <img
                              src={
                                UPLOAD_URL +
                                this.props.profile?.data[0]?.siup_doc
                              }
                              className="img-fluid"
                              alt="siup"
                              style={{ height: "200px" }}
                            />
                          )
                        ) : (
                          <img
                            src={imgDummy}
                            className=" img-thumbnail"
                            alt="ttd"
                            style={{ height: "200px" }}
                          />
                        )}
                      </a>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" lg="6">
                  <Card>
                    <CardHeader>
                      <h4>File Akta pendirian</h4>
                    </CardHeader>
                    <CardBody
                      style={{
                        display: "grid",
                        justifyContent: "center",
                        padding: "15px",
                      }}
                    >
                      <div>
                        <label>
                          <strong>Nomor Akta:</strong>{" "}
                          {this.props.profile?.data[0]?.akta_pendirian}
                        </label>
                      </div>
                      <a
                        href={
                          UPLOAD_URL +
                          this.props.profile?.data[0]?.akta_pendirian_doc
                        }
                        target="_blank"
                      >
                        {this.props.profile?.data[0]?.akta_pendirian_doc ? (
                          <img
                            src={
                              UPLOAD_URL +
                              this.props.profile?.data[0]?.akta_pendirian_doc
                            }
                            className="img-fluid"
                            alt="foto Akta"
                            style={{ height: "200px" }}
                          />
                        ) : (
                          <img
                            src={imgDummy}
                            className=" img-thumbnail"
                            alt="ttd"
                            style={{ height: "200px" }}
                          />
                        )}
                      </a>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" lg="6">
                  <Card>
                    <CardHeader>
                      <h4>File Surat penunjukan shipper</h4>
                    </CardHeader>
                    <CardBody
                      style={{
                        display: "grid",
                        justifyContent: "center",
                        padding: "15px",
                      }}
                    >
                      <div>
                        <label>
                          <strong>Nomor Surat penunjukan shipper:</strong>{" "}
                          {
                            this.props.profile?.data[0]
                              ?.surat_penunjukan_shipper
                          }
                        </label>
                      </div>
                      <a
                        href={
                          UPLOAD_URL +
                          this.props.profile?.data[0]
                            ?.surat_penunjukan_shipper_doc
                        }
                        target="_blank"
                      >
                        {this.props.profile?.data[0]
                          ?.surat_penunjukan_shipper_doc ? (
                          <img
                            src={
                              UPLOAD_URL +
                              this.props.profile?.data[0]
                                ?.surat_penunjukan_shipper_doc
                            }
                            className="img-fluid"
                            alt="foto Surat penunjukan shipper"
                            style={{ height: "200px" }}
                          />
                        ) : (
                          <img
                            src={imgDummy}
                            className=" img-thumbnail"
                            alt="ttd"
                            style={{ height: "200px" }}
                          />
                        )}
                      </a>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="12" lg="6">
                  <Card>
                    <CardHeader>
                      <strong>Surat rekomendasi</strong>
                    </CardHeader>
                    <CardBody
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "15px",
                      }}
                    >
                      <a
                        href={
                          UPLOAD_URL +
                          this.props.profile?.data[0]?.surat_rekomendasi
                        }
                        target="_blank"
                      >
                        {this.props.profile?.data[0]?.surat_rekomendasi ? (
                          this.props.profile?.data[0]?.surat_rekomendasi.indexOf(
                            "pdf"
                          ) !== -1 ? (
                            <iframe
                              src={
                                UPLOAD_URL +
                                this.props.profile?.data[0]?.surat_rekomendasi
                              }
                              title="surat rekomendasi"
                              frameBorder="0"
                              style={{ height: "200px" }}
                              width="100%"
                            ></iframe>
                          ) : (
                            <img
                              src={
                                UPLOAD_URL +
                                this.props.profile?.data[0]?.surat_rekomendasi
                              }
                              className="img-fluid"
                              alt="surat rekomendasi"
                              style={{ height: "200px" }}
                            />
                          )
                        ) : (
                          <img
                            src={imgDummy}
                            className=" img-thumbnail"
                            alt="ttd"
                            style={{ height: "200px" }}
                          />
                        )}
                      </a>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="2">
              <Row>
                <Col sm="12" lg="12">
                  <Card>
                    <CardBody>
                      <AvForm onValidSubmit={this.handleChangePassword}>
                        <Row>
                          <Col lg="6">
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="icon-lock"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="password"
                                name="password"
                                required
                                placeholder="Password Baru"
                              />
                            </InputGroup>
                          </Col>
                          <Col lg="6">
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="icon-lock"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="password"
                                validate={{ match: { value: "password" } }}
                                name="confirm_password"
                                required
                                placeholder="Konfirmasi Password"
                              />
                            </InputGroup>
                          </Col>
                          <Col>
                            <div className="form-button">
                              <button type="submit" className="btn btn-primary">
                                Submit
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </AvForm>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="3">
              <Row>
                <Col sm="12" lg="12">
                  <Card>
                    <CardBody>
                      <h4>Data Perusahaan</h4>
                      <hr></hr>
                      <AvForm
                        onValidSubmit={this.handleSubmit}
                        model={defaultValues}
                      >
                        <Row>
                          <Col xs="12" sm="6" lg="6">
                            <Label htmlFor="name">Nama :</Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-flag"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="nama_perusahaan"
                                onChange={this.onInputChange.bind(this)}
                                placeholder="Nama perusahaan"
                                required
                              />
                              <AvInput type="hidden" name="id" />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="6" lg="6">
                            <Label htmlFor="name">Email :</Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="icon-envelope"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="email"
                                name="email"
                                required
                                placeholder="Email"
                              />
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" sm="6" lg="6">
                            <Label htmlFor="name">Alamat :</Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-map-marker"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="textarea"
                                name="alamat"
                                required
                                placeholder="Alamat"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="6" lg="6">
                            <Label htmlFor="name">Provinsi :</Label>
                            {this.props.provinsiIsSuccess && (
                              <Select
                                name="provinsi_id"
                                className="mb-3"
                                value={provinsi_id}
                                defaultValue={{
                                  label: defaultValues.provinsi,
                                  value: defaultValues.provinsi_id,
                                }}
                                onChange={this.onProvChange}
                                options={this.props.provinsis?.data}
                              />
                            )}
                            <Label htmlFor="name">Kota :</Label>
                            {/* {this.props.kotaIsSuccess && ( */}
                            <Select
                              name="kota_id"
                              className="mb-3"
                              value={kota_id}
                              defaultValue={{
                                label: defaultValues.kota,
                                value: defaultValues.kota_id,
                              }}
                              onChange={this.onKotaChange}
                              options={this.props.kotas?.data}
                            />
                            {/* )} */}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" sm="6" lg="6">
                            <Label htmlFor="name">Fax :</Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-fax"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="fax"
                                required
                                placeholder="No Fax"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="6" lg="6">
                            <Label htmlFor="name">Telephone :</Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-phone"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="telp"
                                required
                                placeholder="No Telp"
                              />
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" sm="6" lg="6">
                            <Label htmlFor="name">Jenis perusahaan :</Label>
                            <Select
                              name="jenis_user"
                              className="mb-3"
                              value={jenis_user}
                              defaultValue={{
                                label: defaultValues.jenis_user,
                                value: defaultValues.jenis_user,
                              }}
                              onChange={this.onJenisChange}
                              options={optionJenis}
                            />
                          </Col>
                          <Col xs="12" sm="6" lg="6">
                            <Label htmlFor="name">Status perusahaan :</Label>
                            <Select
                              name="status_perusahaan"
                              className="mb-3"
                              value={status_perusahaan}
                              defaultValue={{
                                label: defaultValues.status_perusahaan,
                                value: defaultValues.status_perusahaan,
                              }}
                              onChange={this.onStatusChange}
                              options={optionStatus}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="page-links mt-4">
                              <h4>PMKU</h4>
                              <hr></hr>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" sm="12" lg="6">
                            <Label htmlFor="name">Nomor :</Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-flag"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="no_pmku"
                                required
                                placeholder="Nomor PMKU"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="12" lg="6">
                            <Label htmlFor="name">Tanggal :</Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-calendar"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="date"
                                name="tgl_pmku"
                                required
                                placeholder="Tanggal PMKU"
                              />
                            </InputGroup>
                          </Col>
                          <hr></hr>
                        </Row>
                        <Row>
                          <Col xs="12" sm="6" lg="6" className="pb-3">
                            <Label htmlFor="name">SIUP :</Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-file-text-o"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="siup"
                                required
                                placeholder="SIUP"
                              />
                            </InputGroup>
                            <Label htmlFor="name">Upload Siup :</Label>
                            <InputGroup className="mb-3">
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                name="siup_doc"
                                placeholder="Upload SIUP"
                              />
                              <i className="mb-1 mt-1">
                                *JPG/JPEG/PNG/PDF Maksimal {MAX_UPLOAD}
                              </i>
                            </InputGroup>
                            {this.props.profile?.data[0]?.siup_doc ? (
                              this.props.profile?.data[0]?.siup_doc.indexOf(
                                "pdf"
                              ) !== -1 ? (
                                <iframe
                                  src={
                                    UPLOAD_URL +
                                    this.props.profile?.data[0]?.siup_doc
                                  }
                                  title="siup"
                                  frameBorder="0"
                                  height="200px"
                                  width="100%"
                                ></iframe>
                              ) : (
                                <img
                                  src={
                                    UPLOAD_URL +
                                    this.props.profile?.data[0]?.siup_doc
                                  }
                                  className="img-fluid"
                                  alt="siup"
                                />
                              )
                            ) : (
                              <img
                                src={imgDummy}
                                className=" img-thumbnail"
                                alt="ttd"
                                width="200px"
                              />
                            )}
                          </Col>
                          <Col xs="12" sm="6" lg="6" className="pb-3">
                            <Label htmlFor="name">NPWP :</Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-file-text-o"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <NumberFormat
                                className="form-control"
                                format="##.###.###.#-###.###"
                                mask="_"
                                defaultValue={defaultValues.npwp}
                                onValueChange={(values) => {
                                  const { formattedValue, value } = values;
                                  this.handleNPWP(formattedValue);
                                }}
                              />
                            </InputGroup>
                            <Label htmlFor="name">Upload NPWP :</Label>
                            <InputGroup className="mb-3">
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                name="npwp_doc"
                                placeholder="Upload NPWP"
                              />
                              <i className="mb-1 mt-1">
                                *JPG/JPEG/PNG/PDF Maksimal {MAX_UPLOAD}
                              </i>
                            </InputGroup>
                            {this.props.profile?.data[0]?.npwp_doc ? (
                              this.props.profile?.data[0]?.npwp_doc.indexOf(
                                "pdf"
                              ) !== -1 ? (
                                <iframe
                                  src={
                                    UPLOAD_URL +
                                    this.props.profile?.data[0]?.npwp_doc
                                  }
                                  title="npwp"
                                  frameBorder="0"
                                  height="200px"
                                  width="100%"
                                ></iframe>
                              ) : (
                                <img
                                  src={
                                    UPLOAD_URL +
                                    this.props.profile?.data[0]?.npwp_doc
                                  }
                                  className="img-fluid"
                                  alt="npwp"
                                />
                              )
                            ) : (
                              <img
                                src={imgDummy}
                                className=" img-thumbnail"
                                alt="ttd"
                                width="200px"
                              />
                            )}
                          </Col>
                          <Col xs="12" sm="6" lg="6" className="pb-3">
                            <Label htmlFor="name">KTP :</Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-file-text-o"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <NumberFormat
                                className="form-control"
                                defaultValue={defaultValues.ktp}
                                onValueChange={(values) => {
                                  const { formattedValue, value } = values;
                                  this.handleKTP(formattedValue);
                                }}
                              />
                            </InputGroup>
                            <Label htmlFor="name">Upload KTP :</Label>
                            <InputGroup className="mb-3">
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                name="foto_ktp"
                                placeholder="Upload KTP"
                              />
                              <i className="mb-1 mt-1">
                                *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                              </i>
                            </InputGroup>
                            {this.props.profile?.data[0]?.foto_ktp ? (
                              this.props.profile?.data[0]?.foto_ktp.indexOf(
                                "pdf"
                              ) !== -1 ? (
                                <iframe
                                  src={
                                    UPLOAD_URL +
                                    this.props.profile?.data[0]?.foto_ktp
                                  }
                                  title="ktp"
                                  frameBorder="0"
                                  height="200px"
                                  width="100%"
                                ></iframe>
                              ) : (
                                <img
                                  src={
                                    UPLOAD_URL +
                                    this.props.profile?.data[0]?.foto_ktp
                                  }
                                  className="img-fluid"
                                  alt="ktp"
                                />
                              )
                            ) : (
                              <img
                                src={imgDummy}
                                className=" img-thumbnail"
                                alt="ttd"
                                width="200px"
                              />
                            )}
                          </Col>
                          <Col xs="12" sm="6" lg="6" className="pb-3">
                            <Label htmlFor="name">akta pendirian :</Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-file-text-o"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <NumberFormat
                                className="form-control"
                                defaultValue={defaultValues.akta_pendirian}
                                onValueChange={(values) => {
                                  const { formattedValue, value } = values;
                                  this.handleAktaPendiri(formattedValue);
                                }}
                              />
                            </InputGroup>
                            <Label htmlFor="name">
                              Upload akta pendirian :
                            </Label>
                            <InputGroup className="mb-3">
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                name="akta_pendirian_doc"
                                placeholder="Upload akta_pendirian_doc"
                              />
                              <i className="mb-1 mt-1">
                                *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                              </i>
                            </InputGroup>
                            {this.props.profile?.data[0]?.akta_pendirian_doc ? (
                              this.props.profile?.data[0]?.akta_pendirian_doc.indexOf(
                                "pdf"
                              ) !== -1 ? (
                                <iframe
                                  src={
                                    UPLOAD_URL +
                                    this.props.profile?.data[0]
                                      ?.akta_pendirian_doc
                                  }
                                  title="ktp"
                                  frameBorder="0"
                                  height="200px"
                                  width="100%"
                                ></iframe>
                              ) : (
                                <img
                                  src={
                                    UPLOAD_URL +
                                    this.props.profile?.data[0]
                                      ?.akta_pendirian_doc
                                  }
                                  className="img-fluid"
                                  alt="akta_pendirian_doc"
                                />
                              )
                            ) : (
                              <img
                                src={imgDummy}
                                className=" img-thumbnail"
                                alt="ttd"
                                width="200px"
                              />
                            )}
                          </Col>
                          <Col xs="12" sm="6" lg="6" className="pb-3">
                            <Label htmlFor="name">
                              tanda daftar perusahaan :
                            </Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-file-text-o"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <NumberFormat
                                className="form-control"
                                defaultValue={
                                  defaultValues.tanda_daftar_perusahaan
                                }
                                onValueChange={(values) => {
                                  const { formattedValue, value } = values;
                                  this.handleTDP(formattedValue);
                                }}
                              />
                            </InputGroup>
                            <Label htmlFor="name">
                              Upload tanda daftar perusahaan doc :
                            </Label>
                            <InputGroup className="mb-3">
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                name="tanda_daftar_perusahaan_doc"
                                placeholder="Upload tanda daftar perusahaan doc"
                              />
                              <i className="mb-1 mt-1">
                                *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                              </i>
                            </InputGroup>
                            {this.props.profile?.data[0]
                              ?.tanda_daftar_perusahaan_doc ? (
                              this.props.profile?.data[0]?.tanda_daftar_perusahaan_doc.indexOf(
                                "pdf"
                              ) !== -1 ? (
                                <iframe
                                  src={
                                    UPLOAD_URL +
                                    this.props.profile?.data[0]
                                      ?.tanda_daftar_perusahaan_doc
                                  }
                                  title="tanda_daftar_perusahaan_doc"
                                  frameBorder="0"
                                  height="200px"
                                  width="100%"
                                ></iframe>
                              ) : (
                                <img
                                  src={
                                    UPLOAD_URL +
                                    this.props.profile?.data[0]
                                      ?.tanda_daftar_perusahaan_doc
                                  }
                                  className="img-fluid"
                                  alt="tanda_daftar_perusahaan_doc"
                                />
                              )
                            ) : (
                              <img
                                src={imgDummy}
                                className=" img-thumbnail"
                                alt="ttd"
                                width="200px"
                              />
                            )}
                          </Col>
                          <Col xs="12" sm="6" lg="6" className="pb-3">
                            <Label htmlFor="name">
                              surat keterangan domisili :
                            </Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-file-text-o"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <NumberFormat
                                className="form-control"
                                defaultValue={
                                  defaultValues.surat_keterangan_domisili
                                }
                                onValueChange={(values) => {
                                  const { formattedValue, value } = values;
                                  this.handleSKD(formattedValue);
                                }}
                              />
                            </InputGroup>
                            <Label htmlFor="name">
                              Upload surat keterangan domisili doc :
                            </Label>
                            <InputGroup className="mb-3">
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                name="surat_keterangan_domisili_doc"
                                placeholder="Upload surat keterangan domisili doc"
                              />
                              <i className="mb-1 mt-1">
                                *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                              </i>
                            </InputGroup>
                            {this.props.profile?.data[0]
                              ?.surat_keterangan_domisili_doc ? (
                              this.props.profile?.data[0]?.surat_keterangan_domisili_doc.indexOf(
                                "pdf"
                              ) !== -1 ? (
                                <iframe
                                  src={
                                    UPLOAD_URL +
                                    this.props.profile?.data[0]
                                      ?.surat_keterangan_domisili_doc
                                  }
                                  title="surat_keterangan_domisili_doc"
                                  frameBorder="0"
                                  height="200px"
                                  width="100%"
                                ></iframe>
                              ) : (
                                <img
                                  src={
                                    UPLOAD_URL +
                                    this.props.profile?.data[0]
                                      ?.surat_keterangan_domisili_doc
                                  }
                                  className="img-fluid"
                                  alt="surat_keterangan_domisili_doc"
                                />
                              )
                            ) : (
                              <img
                                src={imgDummy}
                                className=" img-thumbnail"
                                alt="ttd"
                                width="200px"
                              />
                            )}
                          </Col>
                          <Col xs="12" sm="6" lg="6" className="pb-3">
                            <Label htmlFor="name">
                              surat penunjukan shipper :
                            </Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-file-text-o"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <NumberFormat
                                className="form-control"
                                defaultValue={
                                  defaultValues.surat_penunjukan_shipper
                                }
                                onValueChange={(values) => {
                                  const { formattedValue, value } = values;
                                  this.handleSPS(formattedValue);
                                }}
                              />
                            </InputGroup>
                            <Label htmlFor="name">
                              Upload surat penunjukan shipper :
                            </Label>
                            <InputGroup className="mb-3">
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                name="surat_penunjukan_shipper_doc"
                                placeholder="Upload surat penunjukan shipper doc"
                              />
                              <i className="mb-1 mt-1">
                                *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                              </i>
                            </InputGroup>
                            {this.props.profile?.data[0]
                              ?.surat_penunjukan_shipper_doc ? (
                              this.props.profile?.data[0]?.surat_penunjukan_shipper_doc.indexOf(
                                "pdf"
                              ) !== -1 ? (
                                <iframe
                                  src={
                                    UPLOAD_URL +
                                    this.props.profile?.data[0]
                                      ?.surat_penunjukan_shipper_doc
                                  }
                                  title="surat_penunjukan_shipper_doc"
                                  frameBorder="0"
                                  height="200px"
                                  width="100%"
                                ></iframe>
                              ) : (
                                <img
                                  src={
                                    UPLOAD_URL +
                                    this.props.profile?.data[0]
                                      ?.surat_penunjukan_shipper_doc
                                  }
                                  className="img-fluid"
                                  alt="surat_penunjukan_shipper_doc"
                                />
                              )
                            ) : (
                              <img
                                src={imgDummy}
                                className=" img-thumbnail"
                                alt="ttd"
                                width="200px"
                              />
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" sm="6" lg="6">
                            <Label htmlFor="name">
                              Upload Surat Rekomendasi :
                            </Label>
                            <InputGroup className="mb-3">
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                name="surat_rekomendasi"
                                placeholder="Upload Surat"
                              />
                              <i className="mb-1 mt-1">
                                *JPG/JPEG/PNG/PDF Maksimal {MAX_UPLOAD}
                              </i>
                            </InputGroup>
                            {this.props.profile?.data[0]?.surat_rekomendasi ? (
                              this.props.profile?.data[0]?.surat_rekomendasi.indexOf(
                                "pdf"
                              ) !== -1 ? (
                                <iframe
                                  src={
                                    UPLOAD_URL +
                                    this.props.profile?.data[0]
                                      ?.surat_rekomendasi
                                  }
                                  title="surat"
                                  frameBorder="0"
                                  height="200px"
                                  width="100%"
                                ></iframe>
                              ) : (
                                <img
                                  src={
                                    UPLOAD_URL +
                                    this.props.profile?.data[0]
                                      ?.surat_rekomendasi
                                  }
                                  className="img-fluid"
                                  alt="surat"
                                />
                              )
                            ) : (
                              <img
                                src={imgDummy}
                                className=" img-thumbnail"
                                alt="ttd"
                                width="200px"
                              />
                            )}
                          </Col>
                          <Col xs="12" sm="6" lg="6">
                            <Label htmlFor="name">Upload Logo :</Label>
                            <InputGroup className="mb-3">
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                name="logo_perusahaan"
                                placeholder="Upload Logo"
                              />
                              <i className="mb-1 mt-1">
                                *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                              </i>
                            </InputGroup>
                            {this.props.profile?.data[0]?.logo_perusahaan ? (
                              <img
                                src={
                                  UPLOAD_URL +
                                  this.props.profile?.data[0]?.logo_perusahaan
                                }
                                className=" img-thumbnail"
                                alt="logo"
                                width="200px"
                              />
                            ) : (
                              <img
                                src={imgDummy}
                                className=" img-thumbnail"
                                alt="ttd"
                                width="200px"
                              />
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="page-links mt-4">
                              <h4>Data Penanda Tangan</h4>
                              <hr></hr>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" sm="4" lg="4">
                            <Label htmlFor="name">Nama :</Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-user"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="nama_ttd"
                                required
                                placeholder="Nama Penanda tangan"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="4" lg="4">
                            <Label htmlFor="name">Upload Tanda Tangan :</Label>
                            <InputGroup className="mb-3">
                              <AvInput
                                className="file-upload"
                                onChange={this.handleFile}
                                bsSize="xs"
                                type="file"
                                name="foto_ttd"
                                placeholder="Upload image ttd"
                              />
                              <i className="mb-1 mt-1">
                                *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                              </i>
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="4" lg="4">
                            {this.props.profile?.data[0]?.foto_ttd ? (
                              <img
                                src={
                                  UPLOAD_URL +
                                  this.props.profile?.data[0]?.foto_ttd
                                }
                                className=" img-thumbnail"
                                alt="ttd"
                                width="200px"
                              />
                            ) : (
                              <img
                                src={imgDummy}
                                className=" img-thumbnail"
                                alt="ttd"
                                width="200px"
                              />
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="page-links mt-4">
                              <h4>Data Officer</h4>
                              <hr></hr>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="4" lg="4">
                            <Card>
                              <CardHeader>
                                <h5>Officer 1</h5>
                              </CardHeader>
                              <CardBody>
                                <Col xs="12" sm="12" lg="12">
                                  <Label htmlFor="name">Nama :</Label>
                                  <InputGroup className="mb-3">
                                    <InputGroupAddon addonType="prepend">
                                      <InputGroupText>
                                        <i className="fa fa-user"></i>
                                      </InputGroupText>
                                    </InputGroupAddon>
                                    <AvInput
                                      type="text"
                                      name="nama_officer1"
                                      required
                                      placeholder="Nama Officer 1"
                                    />
                                  </InputGroup>
                                </Col>
                                <Col xs="12" sm="12" lg="12">
                                  <Label htmlFor="name">Telephone :</Label>
                                  <InputGroup className="mb-3">
                                    <InputGroupAddon addonType="prepend">
                                      <InputGroupText>
                                        <i className="fa fa-phone"></i>
                                      </InputGroupText>
                                    </InputGroupAddon>
                                    <AvInput
                                      type="text"
                                      name="telp_officer1"
                                      required
                                      placeholder="No Telepon Officer 1"
                                    />
                                  </InputGroup>
                                </Col>
                                <Col xs="12" sm="12" lg="12">
                                  <Label htmlFor="name">
                                    Jenis Identitas :
                                  </Label>
                                  <Select
                                    name="identify_officer1"
                                    className="mb-3"
                                    value={identify_officer1}
                                    defaultValue={{
                                      label: defaultValues.identify_officer1,
                                      value: defaultValues.identify_officer1,
                                    }}
                                    onChange={this.onIdentify1}
                                    options={optionIdentify1}
                                  />
                                </Col>
                                <Col xs="12" sm="12" lg="12" className="pt-2">
                                  <Label htmlFor="name">
                                    Upload identitas :
                                  </Label>
                                  <InputGroup>
                                    <AvInput
                                      className="file-upload"
                                      onChange={this.handleFile}
                                      bsSize="xs"
                                      type="file"
                                      id="file-input"
                                      name="identify_officerdoc1"
                                      placeholder="Upload Kartu Identitas"
                                      accept="image/jpeg,image/png"
                                    />
                                    <i className="mb-1 mt-1">
                                      *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                                    </i>
                                  </InputGroup>
                                </Col>
                                <center className="mt-2">
                                  <Media
                                    object
                                    src={
                                      UPLOAD_URL +
                                      this.props.profile?.data[0]
                                        ?.identify_officerdoc1
                                    }
                                    style={{ maxHeight: 500, maxWidth: 300 }}
                                    alt="Generic placeholder image"
                                  />
                                </center>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col sm="4" lg="4">
                            <Card>
                              <CardHeader>
                                <h5>Officer 2</h5>
                              </CardHeader>
                              <CardBody>
                                <Col xs="12" sm="12" lg="12">
                                  <Label htmlFor="name">Nama :</Label>
                                  <InputGroup className="mb-3">
                                    <InputGroupAddon addonType="prepend">
                                      <InputGroupText>
                                        <i className="fa fa-user"></i>
                                      </InputGroupText>
                                    </InputGroupAddon>
                                    <AvInput
                                      type="text"
                                      name="nama_officer2"
                                      required
                                      placeholder="Nama Officer 2"
                                    />
                                  </InputGroup>
                                </Col>
                                <Col xs="12" sm="12" lg="12">
                                  <Label htmlFor="name">Telephone :</Label>
                                  <InputGroup className="mb-3">
                                    <InputGroupAddon addonType="prepend">
                                      <InputGroupText>
                                        <i className="fa fa-phone"></i>
                                      </InputGroupText>
                                    </InputGroupAddon>
                                    <AvInput
                                      type="text"
                                      name="telp_officer2"
                                      required
                                      placeholder="No Telepon Officer 2"
                                    />
                                  </InputGroup>
                                </Col>
                                <Col xs="12" sm="12" lg="12">
                                  <Label htmlFor="name">
                                    Jenis Identitas :
                                  </Label>
                                  <Select
                                    name="identify_officer2"
                                    className="mb-3"
                                    value={identify_officer2}
                                    defaultValue={{
                                      label: defaultValues.identify_officer2,
                                      value: defaultValues.identify_officer2,
                                    }}
                                    onChange={this.onIdentify2}
                                    options={optionIdentify2}
                                  />
                                </Col>
                                <Col xs="12" sm="12" lg="12" className="pt-2">
                                  <Label htmlFor="name">
                                    Upload identitas :
                                  </Label>
                                  <InputGroup>
                                    <AvInput
                                      className="file-upload"
                                      onChange={this.handleFile}
                                      bsSize="xs"
                                      type="file"
                                      id="file-input"
                                      name="identify_officerdoc2"
                                      placeholder="Upload Kartu Identitas"
                                      accept="image/jpeg,image/png"
                                    />
                                    <i className="mb-1 mt-1">
                                      *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                                    </i>
                                  </InputGroup>
                                </Col>
                                <center className="mt-2">
                                  <Media
                                    object
                                    src={
                                      UPLOAD_URL +
                                      this.props.profile?.data[0]
                                        ?.identify_officerdoc2
                                    }
                                    style={{ maxHeight: 500, maxWidth: 300 }}
                                    alt="Generic placeholder image"
                                  />
                                </center>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col sm="4" lg="4">
                            <Card>
                              <CardHeader>
                                <h5>Officer 3</h5>
                              </CardHeader>
                              <CardBody>
                                <Col xs="12" sm="12" lg="12">
                                  <Label htmlFor="name">Nama :</Label>
                                  <InputGroup className="mb-3">
                                    <InputGroupAddon addonType="prepend">
                                      <InputGroupText>
                                        <i className="fa fa-user"></i>
                                      </InputGroupText>
                                    </InputGroupAddon>
                                    <AvInput
                                      type="text"
                                      name="nama_officer3"
                                      required
                                      placeholder="Nama Officer 3"
                                    />
                                  </InputGroup>
                                </Col>
                                <Col xs="12" sm="12" lg="12">
                                  <Label htmlFor="name">Telephone :</Label>
                                  <InputGroup className="mb-3">
                                    <InputGroupAddon addonType="prepend">
                                      <InputGroupText>
                                        <i className="fa fa-phone"></i>
                                      </InputGroupText>
                                    </InputGroupAddon>
                                    <AvInput
                                      type="text"
                                      name="telp_officer3"
                                      required
                                      placeholder="No Telepon Officer 3"
                                    />
                                  </InputGroup>
                                </Col>
                                <Col xs="12" sm="12" lg="12">
                                  <Label htmlFor="name">
                                    Jenis Identitas :
                                  </Label>
                                  <Select
                                    name="identify_officer3"
                                    className="mb-3"
                                    value={identify_officer3}
                                    defaultValue={{
                                      label: defaultValues.identify_officer3,
                                      value: defaultValues.identify_officer3,
                                    }}
                                    onChange={this.onIdentify3}
                                    options={optionIdentify3}
                                  />
                                </Col>
                                <Col xs="12" sm="12" lg="12" className="pt-2">
                                  <Label htmlFor="name">
                                    Upload identitas :
                                  </Label>
                                  <InputGroup>
                                    <AvInput
                                      className="file-upload"
                                      onChange={this.handleFile}
                                      bsSize="xs"
                                      type="file"
                                      id="file-input"
                                      name="identify_officerdoc3"
                                      placeholder="Upload Kartu Identitas"
                                      accept="image/jpeg,image/png"
                                    />
                                    <i className="mb-1 mt-1">
                                      *JPG/JPEG/PNG Maksimal {MAX_UPLOAD}
                                    </i>
                                  </InputGroup>
                                </Col>
                                <center>
                                  <Media
                                    object
                                    src={
                                      UPLOAD_URL +
                                      this.props.profile?.data[0]
                                        ?.identify_officerdoc3
                                    }
                                    style={{ maxHeight: 500, maxWidth: 300 }}
                                    alt="Generic placeholder image"
                                  />
                                </center>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="page-links mt-4">
                              <h4>Data PIC</h4>
                              <hr></hr>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" sm="6" lg="6">
                            <Label htmlFor="name">Nama PIC :</Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-user"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="nama_pic"
                                required
                                placeholder="Nama PIC"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="6" lg="6">
                            <Label htmlFor="name">Email PIC :</Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="icon-envelope"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="email"
                                name="email_pic"
                                required
                                placeholder="Email PIC"
                              />
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" sm="6" lg="6">
                            <Label htmlFor="name">Handphone :</Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-mobile-phone"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="number"
                                name="hp_pic"
                                required
                                placeholder="No HP"
                              />
                            </InputGroup>
                          </Col>
                          <Col xs="12" sm="6" lg="6">
                            <Label htmlFor="name">Telephone :</Label>
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-phone"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="telp_pic"
                                required
                                placeholder="No Tlp PIC"
                              />
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" sm="6" lg="6">
                            <Label htmlFor="name">Fax :</Label>
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fa fa-fax"></i>
                                </InputGroupText>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="fax_pic"
                                required
                                placeholder="Fax PIC"
                              />
                            </InputGroup>
                          </Col>
                        </Row>
                        {this.props.updateLoading ||
                        this.props.shipperUpdateUserLoading ? (
                          <Spinner />
                        ) : (
                          <div className="form-button">
                            <button
                              size="lg"
                              type="submit"
                              className="btn btn-primary mt-4"
                            >
                              Simpan
                            </button>
                          </div>
                        )}
                      </AvForm>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="4">
              <Row>
                <Col sm="4" lg="4">
                  <Card>
                    <CardHeader>
                      <h3>Officer 1</h3>
                    </CardHeader>
                    <CardBody>
                      <center>
                        <Media
                          object
                          src={
                            UPLOAD_URL +
                            this.props.profile?.data[0]?.identify_officerdoc1
                          }
                          style={{ maxHeight: 500, maxWidth: 300 }}
                          alt="Generic placeholder image"
                        />
                      </center>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">
                          <i className="fa fa-user text-primary mr-3"></i>
                          <strong className="s-12">Nama</strong>{" "}
                          <span className="float-right s-12">
                            {this.props.profile?.data[0]?.nama_officer1}
                          </span>
                        </li>
                        <li className="list-group-item">
                          <i className="fa fa-phone text-primary s-15 mr-3"></i>
                          <strong className="s-12">No. Telp</strong>{" "}
                          <span className="float-right s-12">
                            {this.props.profile?.data[0]?.telp_officer1}
                          </span>
                        </li>
                        <li className="list-group-item">
                          <i className="fa fa-file-text-o text-primary s-15 mr-3"></i>
                          <strong className="s-12">Jenis Identitas</strong>{" "}
                          <span className="float-right s-12">
                            {this.props.profile?.data[0]?.identify_officer1}
                          </span>
                        </li>
                      </ul>
                    </CardBody>
                  </Card>
                </Col>
                <Col sm="4" lg="4">
                  <Card>
                    <CardHeader>
                      <h3>Officer 2</h3>
                    </CardHeader>
                    <CardBody>
                      <center>
                        <Media
                          object
                          src={
                            UPLOAD_URL +
                            this.props.profile?.data[0]?.identify_officerdoc2
                          }
                          style={{ maxHeight: 500, maxWidth: 300 }}
                          alt="Generic placeholder image"
                        />
                      </center>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">
                          <i className="fa fa-user text-primary mr-3"></i>
                          <strong className="s-12">Nama</strong>{" "}
                          <span className="float-right s-12">
                            {this.props.profile?.data[0]?.nama_officer2}
                          </span>
                        </li>
                        <li className="list-group-item">
                          <i className="fa fa-phone text-primary s-15 mr-3"></i>
                          <strong className="s-12">No. Telp</strong>{" "}
                          <span className="float-right s-12">
                            {this.props.profile?.data[0]?.telp_officer2}
                          </span>
                        </li>
                        <li className="list-group-item">
                          <i className="fa fa-file-text-o text-primary s-15 mr-3"></i>
                          <strong className="s-12">Jenis Identitas</strong>{" "}
                          <span className="float-right s-12">
                            {this.props.profile?.data[0]?.identify_officer2}
                          </span>
                        </li>
                      </ul>
                    </CardBody>
                  </Card>
                </Col>
                <Col sm="4" lg="4">
                  <Card>
                    <CardHeader>
                      <h3>Officer 3</h3>
                    </CardHeader>
                    <CardBody>
                      <center>
                        <Media
                          object
                          src={
                            UPLOAD_URL +
                            this.props.profile?.data[0]?.identify_officerdoc3
                          }
                          style={{ maxHeight: 500, maxWidth: 300 }}
                          alt="Generic placeholder image"
                        />
                      </center>
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item">
                          <i className="fa fa-user text-primary mr-3"></i>
                          <strong className="s-12">Nama</strong>{" "}
                          <span className="float-right s-12">
                            {this.props.profile?.data[0]?.nama_officer3}
                          </span>
                        </li>
                        <li className="list-group-item">
                          <i className="fa fa-phone text-primary s-15 mr-3"></i>
                          <strong className="s-12">No. Telp</strong>{" "}
                          <span className="float-right s-12">
                            {this.props.profile?.data[0]?.telp_officer3}
                          </span>
                        </li>
                        <li className="list-group-item">
                          <i className="fa fa-file-text-o text-primary s-15 mr-3"></i>
                          <strong className="s-12">Jenis Identitas</strong>{" "}
                          <span className="float-right s-12">
                            {this.props.profile?.data[0]?.identify_officer3}
                          </span>
                        </li>
                      </ul>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </div>
      );
    }
  }

  render() {
    if (this.props.hasError) {
      return (
        <div>
          <p>
            Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi dengan
            internet
          </p>
        </div>
      );
    }

    if (this.props.isLoading) {
      return (
        <div>
          <p>Loading ..... </p>
        </div>
      );
    }

    return <div>{this.renderData()}</div>;
  }
}

ProfileShipper.propTypes = {
  isSuccess: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,

  updateSuccess: PropTypes.bool.isRequired,
  updateError: PropTypes.bool.isRequired,
  updateLoading: PropTypes.bool.isRequired,

  cpwdSuccess: PropTypes.bool.isRequired,
  cpwdError: PropTypes.bool.isRequired,
  cpwdLoading: PropTypes.bool.isRequired,

  provinsiIsSuccess: PropTypes.bool.isRequired,
  provinsiHasError: PropTypes.bool.isRequired,
  provinsiIsLoading: PropTypes.bool.isRequired,

  kotaIsSuccess: PropTypes.bool.isRequired,
  kotaHasError: PropTypes.bool.isRequired,
  kotaIsLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    profile: state.shippers.shipper,
    isSuccess: state.shippers.shipperViewSuccess,
    hasError: state.shippers.shipperViewError,
    isLoading: state.shippers.shipperViewLoading,

    shipperUpdateUserSuccess: state.shippers.shipperUpdateUserSuccess,
    shipperUpdateUserLoading: state.shippers.shipperUpdateUserLoading,
    shipperUpdateUserError: state.shippers.shipperUpdateUserError,

    updateSuccess: state.shippers.shipperAddSuccess,
    updateError: state.shippers.shipperAddError,
    updateLoading: state.shippers.shipperAddLoading,

    cpwdSuccess: state.users.userAddSuccess,
    cpwdError: state.users.userAddError,
    cpwdLoading: state.users.userAddLoading,

    provinsis: state.provinsis.provinsis,
    provinsiIsSuccess: state.provinsis.provinsiGetSuccess,
    provinsiHasError: state.provinsis.provinsiGetError,
    provinsiIsLoading: state.provinsis.provinsiGetLoading,

    kotas: state.kotas.kotas,
    kotaIsSuccess: state.kotas.kotaGetSuccess,
    kotaHasError: state.kotas.kotaGetError,
    kotaIsLoading: state.kotas.kotaGetLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    shipperFetchUser: (parent) => dispatch(shipperFetchUser(parent)),
    shipperUpdate: (parent) => dispatch(shipperUpdate(parent)),
    shipperUpdateProfile: (parent) => dispatch(shipperUpdateProfile(parent)),
    userChangePassword: (parent) => dispatch(userChangePassword(parent)),
    provinsiFetchAll: (parent) => dispatch(provinsiFetchAll(parent)),
    kotaFetchSub: (parent) => dispatch(kotaFetchSub(parent)),
    kotaGetSuccess: (bool, data) => dispatch(kotaGetSuccess(bool, data)),
    doLogout: () => dispatch(doLogout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileShipper);
